<mat-dialog-content>
    <app-local-data-grid-comp
        class="calculation-log-data-grid"
        [sort]="sort"
        [columns]="columns"
        [data]="timeOffCalculationLog"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [pageable]="false"
        category="CalculationLog"
        export="excel"
    ></app-local-data-grid-comp>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
</mat-dialog-actions>